export class BankData {
  name: string;
  code: string;

  static parse(raw: ?any): ?BankData {
    if (!!raw) {
      const data = new BankData();
      data.name = raw.name;
      data.code = raw.code;
      return data;
    }
  }
}

class TransferData {
  target: string;
  banks: Array<BankData>;
  address: string;
  legalID: string;
  phone: string;
  email: string;

  static parse(raw: ?any): ?TransferData {
    if (!!raw) {
      const data = new TransferData();
      data.target = raw.target;
      if (!!raw.banks && Array.isArray(raw.banks)) {
        data.banks = raw.banks.map(bank => BankData.parse(bank));
      }
      data.address = raw.address;
      data.legalID = raw.legalID;
      data.phone = raw.phone;
      data.email = raw.email;
      return data;
    }
  }
}

export default TransferData;
